import type { Column, ColumnDataType } from '../core/types'

interface FilterSubjectProps<TData, TType extends ColumnDataType> {
  column: Column<TData, TType>
}

// No `column.icon` here: every config in data-table-faceted-filter passes the
// same `PlaceholderIcon` circle, so on an applied chip it was decoration sitting
// where a meaningful glyph would go. The icon still renders in the filter
// selector menu, where it keeps the option labels aligned.
export function FilterSubject<TData, TType extends ColumnDataType>({
  column,
}: FilterSubjectProps<TData, TType>) {
  return (
    <span className="flex select-none items-center whitespace-nowrap px-2 font-inter text-s-500 normal-case tracking-normal">
      {column.displayName}
    </span>
  )
}
